module.exports = __webpack_public_path__ + "img/challenge_en_default_img.97d0e95c.png";